/* eslint-disable no-param-reassign */
import React, { Component, Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Table } from 'antd';
import PropTypes from 'prop-types';
import { QUANTITY } from '@Apis/constants';
import H3Text from '@Uilib/h3Text';
import BatchesTable from '@Components/Common/BatchesTable';
import ProductCategoryLabel from '@Components/Common/ProductCategoryLabel';
import PRZModal from '../../../../../Common/UI/PRZModal';
import './style.scss';

/**
 *
 */
class ByProduct extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      productListColumns: [
        {
          title: 'PRODUCT',
          width: '350px',
          render: (text, record) => (
            <div className="mpe-bp-table__product-name">
              <div onClick={() => this.setState({ showPRZModal: true, selectedDocumentId: record?.product_sku_info?.product_sku_id })}>
                <a>
                  {`#${record?.product_sku_info?.internal_sku_code}`}
                </a>
              </div>
              &nbsp;
              <span>
                {`${record?.product_sku_info?.ref_product_code ? `${record?.product_sku_info?.ref_product_code} - ` : ''}${record?.product_sku_info?.product_sku_name}`}
              </span>
              <H3Text className="table-subscript-grey" text={`#${record?.product_batches?.[0]?.custom_batch_number}`} />
              {record?.product_category_info?.category_path?.length > 0 && (
                <ProductCategoryLabel
                  categoryPath={record?.product_category_info?.category_path}
                  categoryName={record?.product_category_info?.category_path?.at(-1)}
                  containerStyle={{
                    width: 'fit-content',
                  }}
                />
              )}
            </div>
          ),
        },
        {
          title: 'PRODUCED',
          width: '180px',
          render: (text, record) => (
            <Fragment>
              {`${QUANTITY(record?.quantity, record?.uom_info?.precision)} ${record?.uom_info?.uqc?.toProperCase()}`}
            </Fragment>
          ),
        },
      ],
    };
  }

  /**
   *
   */
  componentDidMount() {
  }

  /**
   *
   * @param {*} data
   * @return
   */
  getDataSource(data) {
    if (data) {
      return JSON.parse(JSON.stringify(data));
    }
    return [];
  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      data, loading, isFlexible,
    } = this.props;
    const {
      productListColumns, showPRZModal, selectedDocumentId
    } = this.state;
    return (
      <Fragment>
        <div className="bpe-table-wrapper">
          <Table
            bordered
            loading={loading}
            showHeader
            size="small"
            columns={isFlexible ? productListColumns : productListColumns?.filter((item) => item.title)}
            dataSource={data?.map((item) => ({
              ...item,
              product_category_info: item?.product_sku_info?.product_category_info,
            }))}
            pagination={false}
            expandable={{
              rowExpandable: (record) => record?.product_batches?.length,
              expandedRowRender: (record) => (
                <BatchesTable
                  title="Produced Batch"
                  batches={record?.product_batches}
                  uomInfo={record?.uom_info}
                  productInfo={record?.product_sku_info}
                  expiryDays={record?.product_sku_info?.expiry_days}
                  showCancel
                />
              ),
            }}
          />
        </div>
        <PRZModal
          isOpen={showPRZModal}
          onClose={() => {
            this.setState({ showPRZModal: false, selectedDocumentId: null });
          }}
          entityType="product"
          documentId={selectedDocumentId}
        />
      </Fragment>
    );
  }
}

/**
 *
 * @param UserReducers
 * @param PurchaseOrderReducers
 * @return {{updateCustomPurchaseOrderLoading: *, selectedPurchaseOrder, user}}
 */
const mapStateToProps = ({
  UserReducers,
}) => ({
  user: UserReducers.user,
});

/**
 *
 * @return {{}}
 */
const mapDispatchToProps = () => ({

});

ByProduct.propTypes = {
  loading: PropTypes.bool,
  data: PropTypes.any,
  isFlexible: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ByProduct));
